<template>
    <div id="settings">
        <div>
            <div>
                <span>Абонемент</span>
                {{ account.account.login }}
            </div>
            <div>
                <span>Пакет</span>
                {{ account.account.packet_name }}
            </div>
            <div>
                <span>Дата окончания</span>
                {{ account.account.packet_expire | datetime }}
            </div>
            <div>
                <span>Сервер вещания</span>
                <select :value="account.settings.stream_server.value" @change="sendSettings($event, 'stream_server')">
                    <option v-for="(server, index) in account.settings.stream_server.list" :key="index" :value="server.ip">{{ server.descr }}</option>
                </select>
            </div>
            <div>
                <span>Таймшифт</span>
                <select :value="account.settings.timeshift.value" @change="sendSettings($event, 'timeshift')">
                    <option v-for="(value, index) in account.settings.timeshift.list" :key="index" :value="value">{{ value }}</option>
                </select>
            </div>
            <div>
                <span>Кеширование</span>
                <select :value="account.settings.http_caching.value" @change="sendSettings($event, 'http_caching')">
                    <option v-for="(value, index) in account.settings.http_caching.list" :key="index" :value="value">{{ value }}</option>
                </select>
            </div>
            <!-- <div v-if="account.settings.teleteka">
                <label class="checkbox-wrapper">
                    <span>Показывать телетеку <img v-show="account.settings.teleteka.value" src="dist/icon-check.svg"></span>
                    <input type="checkbox" @change="sendSettings('teleteka')" v-model="account.settings.teleteka.value">
                </label>
            </div> -->
            <div>
                <div class="link-wrapper">
                    <span @click="changeProtectedCodeMode = !changeProtectedCodeMode">Сменить родительский пароль</span>
                    <div v-show="changeProtectedCodeMode">
                        <input placeholder="Старый родительский пароль" v-model="oldProtectedCode">
                        <input placeholder="Новый родительский пароль" v-model="newProtectedCode">
                        <input placeholder="Повторите новый пароль" v-model="confirmProtectedCode">
                        <div style="text-align: center;">
                            <a href="#" @click.prevent="changeProtectedCode" :disabled="!(oldProtectedCode && newProtectedCode && confirmProtectedCode)">Подтвердить</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <label class="checkbox-wrapper">
                    <span>Показывать телетеку <img v-show="$parent.teletekaEnabled" src="dist/icon-check.svg"></span>
                    <input type="checkbox" v-model="$parent.teletekaEnabled">
                </label>
            </div>
            <div>
                <label class="checkbox-wrapper">
                    <span>Показывать статистику <img v-show="debugSettings.statsEnabled" src="dist/icon-check.svg"></span>
                    <input type="checkbox" @change="toggleStats(statsEnabled)" v-model="statsEnabled">
                </label>
            </div>
            <div>
                <label class="checkbox-wrapper">
                    <span>Показывать метрику <img v-show="debugSettings.metricsEnabled" src="dist/icon-check.svg"></span>
                    <input type="checkbox" @change="toggleMetrics(metricsEnabled)" v-model="metricsEnabled">
                </label>
            </div>
            <div>
                <!--<a title="Выход" href="#" @click.prevent="logout"><i class="icon-power"></i> Выйти</a>-->
                <a title="Выход" href="#" @click.prevent="logout">Выйти</a>
            </div>
        </div>
    </div>
</template>
<script>
    import Server from './../libs/server'
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                changeProtectedCodeMode: false,
                oldProtectedCode: '',
                newProtectedCode: '',
                confirmProtectedCode: '',
                statsEnabled: false,
                metricsEnabled: false
            }
        },
        computed: {
            ...mapState({
                debugSettings: state => state.debug.debugSettings,
                account: state => state.login.account,
                tab: state => state.tab.tab
            })
        },
        methods: {
            ...mapActions([
                'showToast',
                'showError',
                'setDebugStats',
                'setDebugMetrics',
                'changeSetting'
            ]),
            changeProtectedCode() {
                Server.changeProtectionCode({
                    oldCode: this.oldProtectedCode,
                    newCode: this.newProtectedCode,
                    confirmCode: this.confirmProtectedCode
                }, (err, data) => {
                    if (err) {
                        console.error(err.message);
                        location.reload();
                    }
                    else {
                        if (data.error) {
                            this.showError(data.error);
                        }
                        else {
                            this.oldProtectedCode = this.newProtectedCode = this.confirmProtectedCode = '';
                            this.changeProtectedCodeMode = false;
                            this.showToast({
                                message: 'Код успешно изменен'
                            })
                        }
                    }
                });
            },
            sendSettings(event, k) {
                this.changeSetting({
                    key: k,
                    value: event.target.value
                })
                
                this.$parent.apiSendSettings(k)
            },
            toggleStats(value) {
                this.setDebugStats(value);
            },
            toggleMetrics(value) {
                this.setDebugMetrics(value);
            },
            logout() {
//                this.$parent.getLogout();
                this.$emit('getLogout');
            }
        },
        filters: {
            datetime(v) {
                let time = new Date(v * 1000), // Todo: добавить сдвиг относительно сервера
                    month = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']
                return time.getDate() + ' ' + month[time.getMonth()] + ' ' + time.getFullYear()
            }
        }
    }
</script>
<style>
    #settings {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        overflow-y: scroll;
        z-index: 10;
        background: rgba(0, 0, 0, .75);
    }

    #settings > div {
        width: 20%;
        /*margin: 120px auto 0;*/
        margin: 100px auto 100px;
    }

    #settings > div > div {
        position: relative;
        background: transparent no-repeat 2px 50%;
        padding: 10px;
        border-bottom: solid 1px rgba(255, 255, 255, .1);
        font-size: 17px;
    }

    #settings > div > div:last-child {
        border: 0;
    }

    #settings > div > div:hover {
        background-color: rgba(0, 0, 0, .6);
    }

    #settings > ul > li span, #settings > div span {
        font-size: 14px;
        line-height: 16px;
        text-transform: uppercase;
        display: block;
        color: #efefef;
    }

    #settings > div select {
        text-transform: uppercase;
        display: block;
        width: 100%;
        padding: 6px;
        background: rgba(0, 0, 0, .25);
        border: solid 1px rgba(0, 0, 0, .25);
        border-bottom: solid 1px rgba(255, 255, 255, .15);
        display: block;
        border-radius: 6px;
        margin: 4px 0;
        color: #fff;
        font-size: 21px;
    }

    #settings select option {
        background: #2a2a2a;
        border: 0;
    }

    label.checkbox-wrapper > span {
        cursor: pointer;
    }

    label.checkbox-wrapper > span:hover {
        text-decoration: underline;
    }

    label.checkbox-wrapper > input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .link-wrapper > span {
        cursor: pointer;
    }

    .link-wrapper > span:hover {
        text-decoration: underline;
    }

    .link-wrapper input {
        border: none;
        /* outline: none; */
        /* background: transparent; */
        /* background: rgba(0, 0, 0, 0.5); */
        /* color: #fff; */
        padding: 5px 10px;
        font-size: 15px;
        box-sizing: border-box;
        width: 100%;
        display: block;
        margin: 10px 0px;
    }

    #settings a {
        color: #fff;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 14px;
    }

    #settings a[disabled="disabled"] {
        color: #616060;
        pointer-events: none;
    }

    #settings a:hover {
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// Settings.vue?43430d05